<template>
  <v-combobox
    :value="value" :items="columns" outlined dense hide-details :label="label"
    @input="$emit('input', $event || '')" @change="$emit('input', $event || '')"
  />
</template>

<script>
import { knownColumns } from './editorState'

// A column name box that suggests the columns found by the last preview run of the dataset
// (and still accepts any typed name).
export default {
  name: 'RbFieldPicker',
  props: {
    value: { type: String, default: '' },
    dataset: { type: String, default: '' },
    label: { type: String, default: 'Column' }
  },
  computed: {
    columns () { return knownColumns(this.dataset) }
  }
}
</script>
